import React from 'react';
import PropTypes from 'prop-types';
import { bem } from 'helpers/class-name';
import './CardSection.scss';

const { block } = bem('card-section');

const CardSection = ({ as: Component = 'div', flush, className, ...props }) => (
  <Component className={block(className, { flush })} {...props} />
);

CardSection.propTypes = {
  as: PropTypes.oneOfType([PropTypes.string, PropTypes.func, PropTypes.elementType]),
  className: PropTypes.string,
  flush: PropTypes.bool,
};

export default CardSection;
